import React, { ReactElement, Component, useContext, useEffect, useMemo } from "react";
import { injectIntl } from 'react-intl';
import './quota-management.less';
import { quota_type, QuotaContext } from "../../contexts/quota-management";
import { ItemsContext, item } from "../../contexts/items";
// import Cards from "../../components/cards/cards";
import { SearchTitleContext } from "../../contexts/search-title";
import { CardSelectableContext } from "../../contexts/card-selectable";
import { left_menu_item, LeftMenuContext, menu_items } from "../../contexts/left-menu";
import { WorkspaceContext, workspaces_type_item } from "../../contexts/workspaces";
import { http_get, http_request, response_type, destroy_worker } from "../../worker/http-func";
import { IsInTabsContext } from "../../contexts/is-in-tabs";
import { NamespaceContext, namespaces_type_item } from "../../contexts/namespaces";
import TableList from "../../components/table-list/table-list";
import { TableDescContext } from "../../contexts/table-desc";
import { IsFreshContext } from "../../contexts/is_fresh";
import { ClusterSelectedContext } from "../../contexts/cluster-selected";
import { WorkSpaceSelectedContext } from "../../contexts/workspace-selected";
// import { WorkSpaceSelectedOldContext } from "../../contexts/workspace-selected-old";
import { UserInfoContext, IUserInfoType } from "../../contexts/user-info";
import { clusters_type_item, ClusterContext } from "../../contexts/clusters";
import { DatacenternameContext } from "../../contexts/datacenter-name";
import { SortFirstContext } from "../../contexts/sort-first";

// interface type_new {
//   [key: string]: any;
// }

// interface workspace_item_selected {
//   metadata: {
//     name: string,
//     labels: {
//       name: string
//     }
//   }
// }

const QuotaList: React.FC = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
  const [workspaces, set_workspaces]: [workspaces_type_item[] | undefined, React.Dispatch<React.SetStateAction<workspaces_type_item[] | undefined>>] = useContext(WorkspaceContext),
    set_namespaces: React.Dispatch<React.SetStateAction<namespaces_type_item[] | undefined>> = useContext(NamespaceContext)[1],
    [quotas, set_quotas]: [quota_type['items'], React.Dispatch<React.SetStateAction<quota_type['items']>>] = useContext(QuotaContext),
    user_info: IUserInfoType = useContext(UserInfoContext)[0],
    set_items: React.Dispatch<React.SetStateAction<item[]>> = useContext(ItemsContext)[1],
    set_search_title: React.Dispatch<React.SetStateAction<string>> = useContext(SearchTitleContext)[1],
    set_card_selectable: React.Dispatch<React.SetStateAction<boolean>> = useContext(CardSelectableContext)[1],
    set_left_menu_items: React.Dispatch<React.SetStateAction<left_menu_item[]>> = useContext(LeftMenuContext)[1],
    path: string = props.location.pathname.substring(1).substring(props.location.pathname.substring(1).indexOf('/') + 1),
    set_is_in_tabs: React.Dispatch<React.SetStateAction<boolean>> = useContext(IsInTabsContext)[1],
    set_table_desc: React.Dispatch<React.SetStateAction<string[]>> = useContext(TableDescContext)[1],
    is_fresh: boolean = useContext(IsFreshContext)[0],
    cluster_selected: item | undefined = useContext(ClusterSelectedContext)[0],
    [clusters, set_clusters]: [clusters_type_item[], React.Dispatch<React.SetStateAction<clusters_type_item[]>>] = useContext(ClusterContext),
    [workspace_selected, set_workspace_selected]: [item | undefined, React.Dispatch<React.SetStateAction<item | undefined>>] = useContext(WorkSpaceSelectedContext),
    //  set_workspace_selected: React.Dispatch<React.SetStateAction<item>> = useContext(WorkSpaceSelectedContext)[1],
    //  [workspace_selected_old, set_workspace_selected_old]: [string, React.Dispatch<React.SetStateAction<string>>] = useContext(WorkSpaceSelectedOldContext),
    set_cluster_selected: React.Dispatch<React.SetStateAction<item | undefined>> = useContext(ClusterSelectedContext)[1],
    datacenter_name: string | undefined = useContext(DatacenternameContext)[0],
    sort_first: string = useContext(SortFirstContext)[0],

    { formatMessage } = useMemo(() => props.intl, [props]);

  // useEffect((): void => {
  //   clusters.length <= 0 && user_info.role !== '' && datacenter_name !== '' && http_get('quotas', ['clusters', set_clusters], user_info.role);
  //   // eslint-disable-next-line
  // }, [set_clusters, user_info.role]);

  useEffect(() => () => { destroy_worker() }, []);
  useEffect(() => {
    if (Array.isArray(clusters)) {
      const cluster_selected_find = clusters.find((cluster: clusters_type_item) => cluster.metadata.name === sessionStorage.getItem('cluster')),
        cluster_selected_val = cluster_selected_find ? cluster_selected_find.metadata : ((clusters && clusters[0] && clusters[0].metadata) || {});
      cluster_selected_val.name && (cluster_selected_val.name !== (cluster_selected || {}).name) && set_cluster_selected(cluster_selected_val);
    }
  }, [clusters, cluster_selected, set_cluster_selected]);

  useEffect(() => {
    if (workspaces) {
      const workspace_selected_find = workspaces.find((workspace: workspaces_type_item) => workspace.metadata.name === sessionStorage.getItem('workspace')),
        workspace_selected_val = workspace_selected_find ? workspace_selected_find.metadata : ((workspaces && workspaces[0] && workspaces[0].metadata) || {});
      workspace_selected_val.name && (workspace_selected_val.name !== (workspace_selected || {}).name) && set_workspace_selected(workspace_selected_val);
    }
  }, [workspaces, workspace_selected, set_workspace_selected]);

  useEffect((): void => {
    (async (): Promise<void> => {
      if (path.includes('workspace-quotas')) user_info.role !== '' && datacenter_name && http_get('workspacequotas_page', ['clusters', set_clusters], user_info.role, user_info.subscription_id, datacenter_name, '');
      else if (user_info.role && datacenter_name)
        await http_get('namespacequotas_page', ['clusters', set_clusters], user_info.role, user_info.subscription_id, datacenter_name, '');
    })();
  }, [set_quotas, set_workspaces, set_namespaces, path, is_fresh, user_info.role, user_info.subscription_id, set_clusters, datacenter_name]);

  useEffect((): void => {
    (async () => {
      if (user_info.role !== '' && cluster_selected?.name && datacenter_name) {
        if ((user_info.role === "workspaceOwner" && user_info.wkOwner_has_namespacedeveloper.includes(cluster_selected?.name) && path.includes('namespace-quotas')) || user_info.role === 'namespaceDeveloper') {
          const workspacenames: { name: string, id: string }[] = (await http_request('workspacenames', props, undefined, `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected.name}/workspacenames`, 0, user_info.role, user_info.subscription_id, datacenter_name, cluster_selected.name || '', undefined, undefined, undefined, undefined, true) as response_type).items as { name: string, id: string }[];
          workspacenames && set_workspaces(workspacenames.map(({ name, id }) => { return { metadata: { name: id, labels: { name } } } as workspaces_type_item }));
        } else {
          http_request('workspaces', props, set_workspaces, `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected.name}/workspaces`, 0, user_info.role, user_info.subscription_id, datacenter_name, cluster_selected.name || '', undefined, undefined, undefined, undefined, true); 
        }
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cluster_selected?.name, user_info.role, user_info.subscription_id, user_info.role, user_info.wkOwner_has_namespacedeveloper, set_workspaces]);

  // useEffect(() => {
  //   set_workspace_selected_old('')
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [workspaces]);

  useEffect((): void => {
    if (cluster_selected?.name && workspace_selected?.name && props.location.pathname === '/quotas/namespace-quotas' && user_info.role && datacenter_name) {
      http_request('namespaces', props, set_namespaces, `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected.name}/workspace/${workspace_selected.name}/namespaces`, 0, user_info.role, user_info.subscription_id, datacenter_name, '', undefined, undefined, undefined, undefined, true);
      http_request('namespacequotas', props, set_quotas, `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected.name}/workspace/${workspace_selected.name}/namespacequotas`, 0, user_info.role, user_info.subscription_id, datacenter_name, '');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cluster_selected?.name, props.location.pathname, user_info.role, set_quotas, user_info.subscription_id, workspace_selected?.name]);

  useEffect((): void => {
    (async () => {
      cluster_selected?.name && props.location.pathname !== '/quotas/namespace-quotas' && user_info.role && datacenter_name &&
        await http_request('workspacequotas', props, set_quotas, `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected.name}/workspacequotas`, 0, user_info.role, user_info.subscription_id, datacenter_name, '');
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cluster_selected?.name, props.location.pathname, user_info.role, set_quotas, user_info.subscription_id]);

  useEffect((): void => {
    set_card_selectable(false);
  }, [set_card_selectable]);

  useEffect((): void => {
    set_left_menu_items(menu_items[3]);
  }, [set_left_menu_items]);

  useEffect((): void => {
    set_is_in_tabs(false);
  }, [set_is_in_tabs]);

  useEffect((): void => {
    set_table_desc([...path === 'workspace-quotas' ? [formatMessage({ id: 'workspace_quotas' }), formatMessage({ id: 'workspace_quotas_desc' })] : [formatMessage({ id: 'namespace_quotas' }), formatMessage({ id: 'namespace_quotas_desc' })]]);
  }, [set_table_desc, path, formatMessage]);

  useEffect((): void => {
    const quotas_new: any = Array.isArray(quotas) && quotas.map(
      quota => {
        const spec = quota.spec, quotas_each = spec?.quotas && spec.quotas, name = quota.metadata?.name;
        if (path.includes('namespace-quotas')) {
          // const key_old: string[] = [
          //   'limits.cpu',
          //   'limits.memory',
          //   'limits.ephemeral-storage',
          //   'requests.storage'
          // ],
          //   key_new: string[] = [
          //     'limitsCPU',
          //     'limitMemory',
          //     'limitsRootfs',
          //     'limitsDisk'
          //   ];

          if (quotas_each) {
            // key_old.forEach((key: string, index: number) => {
            //   ((quotas_each as type_new)[key_new[index]] = (quotas_each as type_new)[key]);
            //   delete (quotas_each as type_new)[key];
            // });
            const { limitCPU, limitMemory, pods, gpu } = quotas_each;
            (quota.metadata = Object.assign({ limitCPU, limitMemory, pods, gpu }, quota.metadata));
          }
        }

        let limitsCPU, limitMemory, limitsRootfs, pods, limitsDisk, persistentvolumeclaims, configmaps, secrets, services, gpu, requestsCPU, requestsRootfs, requestMemory;
        if (quotas_each) {
          limitsCPU = quotas_each.limitCPU || quotas_each.limitCPU === '0' ? ((quotas_each.limitCPU === '*' || quotas_each.limitCPU === '0') ? 'Unlimited' : quotas_each.limitCPU) : 'Unlimited';
          requestsCPU = quotas_each.requestCPU ? (quotas_each.requestCPU === "*" || quotas_each.requestCPU === "0" ? "Unlimited" : quotas_each.requestCPU) : "Unlimited";
          limitMemory = quotas_each.limitMemory ? (quotas_each.limitMemory === '*' ? 'Unlimited' : quotas_each.limitMemory) : 'Unlimited';
          requestMemory = quotas_each.requestMemory ? (quotas_each.requestMemory === "*" ? "Unlimited" : quotas_each.requestMemory) : "Unlimited";
          limitsRootfs = quotas_each.limitsRootfs ? (quotas_each.limitsRootfs === '*' ? 'Unlimited' : quotas_each.limitsRootfs) : 'Unlimited';
          requestsRootfs = quotas_each.requestRootfs ? (quotas_each.requestRootfs === "*" ? "Unlimited" : quotas_each.requestRootfs) : "Unlimited";
          pods = quotas_each.pods ? (quotas_each.pods === '*' ? 'Unlimited' : quotas_each.pods) : 'Unlimited';
          gpu = quotas_each.gpu ? (quotas_each.gpu === "*" ? "Unlimited" : quotas_each.gpu) : 0;
          limitsDisk = quotas_each.limitsDisk ? (quotas_each.limitsDisk === '*' ? 'Unlimited' : quotas_each.limitsDisk) : 'Unlimited';
          persistentvolumeclaims = quotas_each.persistentvolumeclaims ? (quotas_each.persistentvolumeclaims === '*' ? 'Unlimited' : quotas_each.persistentvolumeclaims) : 'Unlimited';
          configmaps = quotas_each.configmaps ? (quotas_each.configmaps === '*' ? 'Unlimited' : quotas_each.configmaps) : 'Unlimited';
          secrets = quotas_each.secrets ? (quotas_each.secrets === '*' ? 'Unlimited' : quotas_each.secrets) : 'Unlimited';
          services = quotas_each.services ? (quotas_each.services === '*' ? 'Unlimited' : quotas_each.services) : 'Unlimited';
        }

        return {
          // @ts-ignore
          name,
          limitsCPU,
          requestsCPU,
          limitMemory,
          requestMemory,
          limitsRootfs,
          requestsRootfs,
          pods,
          gpu,
          limitsDisk,
          persistentvolumeclaims,
          configmaps,
          secrets,
          services,
          quotas: quotas_each,
          ...quota.metadata
        };
      });
    set_items(sort_first ? quotas_new.filter((item: item) => (item.name === sort_first)).concat(quotas_new.filter((item: item) => (item.name !== sort_first))) : quotas_new);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [set_items, quotas, is_fresh, path]);

  useEffect(() => {
    set_search_title('quotas');
  }, [set_search_title]);

  return (
    // <Cards />
    <TableList />
  )
}

export default injectIntl(QuotaList);
